<template>
  <base-list-overview
    controller="CarePartner"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'CarePartnersOverview',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ]
}
</script>
